import Ajax from '../../../../util/ajax';
export function zigbeeLockDoor(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/0x0101/command/lock-door';
        const value = {
            'code': payload.code
        };
        ajax.post(url, value);
    };
}
